import { gql } from '@apollo/client';

export const CREDIT = gql`
  query {
    postsCreditByUser 
  }
`;
